(function () {
  pagination(true);
})();

(function () {
  if (!document.body.classList.contains("post-template")) return;

  const cover = document.querySelector(".gh-cover");
  if (!cover) return;

  const image = cover.querySelector(".gh-cover-image");

  window.addEventListener("load", function () {
    cover.style.setProperty(
      "--cover-height",
      (image.clientWidth * image.naturalHeight) / image.naturalWidth + "px"
    );
    cover.classList.remove("loading");
  });
})();

let mediaItems = [];

const loadMedia = async () => {
  const mediaEndpoint = "https://dash.indonesienieuws.nl/api";

  const mediaDivs = document.querySelectorAll("#media");
  const res = await fetch(mediaEndpoint, { mode: "cors" });

  mediaItems = await res.json();
  if (!mediaItems.length) return;

  for (const mediaDiv of mediaDivs) createMediaItem(mediaDiv);
};

const createMediaItem = (parentEl) => {
  parentEl.style.maxHeight = "calc(144px + 2rem)";
  parentEl.style.height = "calc(144px + 2rem)";

  setTimeout(() => {
    setCurrentMedia(parentEl);
    if (mediaItems.length > 1)
      setInterval(() => setCurrentMedia(parentEl), 5000);
  }, 500); // Should have timeout of parentEl's transition
};

const setCurrentMedia = (parentEl) => {
  const oldElement = parentEl.querySelector("#media-item");
  const anchorEl = document.createElement("a");
  parentEl.appendChild(anchorEl);
  const imgEl = document.createElement("img");
  anchorEl.appendChild(imgEl);
  anchorEl.classList.add("media-item");
  anchorEl.setAttribute("id", "media-item");

  const dataId = oldElement?.getAttribute("data-id");
  const randomItem = getRandomItem(mediaItems, dataId);
  anchorEl.setAttribute("data-id", randomItem.id);
  imgEl.src = randomItem.path;
  imgEl.alt = randomItem.description ?? "";
  anchorEl.href = randomItem.url;
  anchorEl.target = "_blank";
  anchorEl.referrerPolicy = "noreferrer";

  if (oldElement) {
    oldElement.style.zIndex = "5";
    oldElement.style.opacity = "0";

    setTimeout(() => oldElement.remove(), 1000);
  }

  anchorEl.style.opacity = "1";
};

const getRandomItem = (inputItems, itemId) => {
  let items = [...inputItems];
  if (itemId && !isNaN(itemId))
    items = items.filter(({ id }) => id !== +itemId);

  // const shuffledItems = shuffleArr(items);

  return items[Math.floor(Math.random() * items.length)];
};

document.addEventListener("DOMContentLoaded", loadMedia);

// const shuffleArr = (inputArr) => {
//   const array = [...inputArr];
//   let currentIndex = array.length,
//     randomIndex;

//   while (currentIndex != 0) {
//     randomIndex = Math.floor(Math.random() * currentIndex);
//     currentIndex--;

//     [array[currentIndex], array[randomIndex]] = [
//       array[randomIndex],
//       array[currentIndex],
//     ];
//   }

//   return array;
// };
